// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  apiUrl: 'https://api.reda.mx',
  urlShop: "https://eshop-api.reda.mx/",
  keyStripe: "pk_live_51JIHluIVw2VmbOMFXei3aZClzeXPdfgmyJGjml0HrQUAvdZAINGirV2VuXxJn1XKQ3xou6yIdGvtqUE5cUWItaQ600vqnUgu9B",
  /*  keyStripe: "pk_live_51JIHluIVw2VmbOMFXei3aZClzeXPdfgmyJGjml0HrQUAvdZAINGirV2VuXxJn1XKQ3xou6yIdGvtqUE5cUWItaQ600vqnUgu9B", */
  defaultMenuType: 'menu-default',
  subHiddenBreakpoint: 1440,
  menuHiddenBreakpoint: 768,
  themeColorStorageKey: 'vien-themecolor',
  isMultiColorActive: true,
  token: "",
  idEmpresaAfiliada: -1,
  idUsuarioSeccion: -1,
  rutaLogoPromos: "https://www.reda.mx/recursos/promos/",
  rutaLandingProyectos: "https://www.reda.mx/recursos/landingproyectos/",
  rutaLogoProyectos: "https://www.reda.mx/recursos/proyectos-empresa/",
  rutaLogoBrochureProyectos: "https://www.reda.mx/recursos/proyectos-empresa/",
  rutaLogoBrochureModelos: "https://www.reda.mx/recursos/proyectos-empresa/",
  rutaLogoUsuario: "https://www.reda.mx/recursos/usuarios/",
  rutaLogoEmpresasAfiliadas: "https://www.reda.mx/recursos/logos/",
  rutaRecursos: "http://192.168.100.39:45457/",
  rutaModelosProyecto: "https://www.reda.mx/recursos/proyectos-empresa/",
  rutaViasProspeccionLogo: "https://www.reda.mx/recursos/viaProspeccionCatalogo/",
  contenidoWhatsapp: "https://reda.mx/apiMultiDeviced/usuarios/chatProspectos/1/",
  rutaProductos: "https://www.reda.mx/recursos/reda-bs/",
  rutaLineasProductos: "https://www.reda.mx/recursos/reda-bs/",
  apiMeta: "https://metaface.reda.mx/",
  rutaIncentivos: "https://www.reda.mx/recursos/incentivos/",
  rutaEvidenciasProyectoLote: "https://www.reda.mx/recursos/evidenciasLotes/",


  apiUrlWhatsapp: 'https://whatsapp.reda.mx/recupera_templates',
  apiUrlQrWhatsapp: 'https://whatsapp.reda.mx/generate-qr',
  apiUrlMasivoWhatsapp: 'https://reda.mx:8080/Whatsapp_enviarMasivo',
  apiUrlSincronizaTemplateWhatsapp: 'https://whatsapp.reda.mx/genera_templates',
  apiUrlImportarProcesosWhatsapp: 'https://whatsapp.reda.mx/genera_templates',

  supabaseUrl: 'https://qerhvquftjwdhfnyedgg.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFlcmh2cXVmdGp3ZGhmbnllZGdnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY3MTcwMzEsImV4cCI6MjA2MjI5MzAzMX0.iPLbKSKIZXuQ-urids-hUEZraVajVe7EYsMmRxq_2U4',

  // Stripe Payment Element para pagos de IA
  stripePublishableKey: 'pk_test_51JIHluIVw2VmbOMFYtymXlX1lESm1Gq6djXKLcFVYwvzElneng8wekQvGbEZFOqPUnxetSZqsFKJDc0fjUnaKOFK00OnF7TrmI',

  /*
  Color Options:
  'light.blueyale', 'light.blueolympic', 'light.bluenavy', 'light.greenmoss', 'light.greenlime', 'light.yellowgranola', 'light.greysteel', 'light.orangecarrot', 'light.redruby', 'light.purplemonster'
  'dark.blueyale', 'dark.blueolympic', 'dark.bluenavy', 'dark.greenmoss', 'dark.greenlime', 'dark.yellowgranola', 'dark.greysteel', 'dark.orangecarrot', 'dark.redruby', 'dark.purplemonster'
  */
  defaultColor: 'light.blueyale',
  isDarkSwitchActive: true,
  defaultDirection: 'ltr',
  themeRadiusStorageKey: 'vien-themeradius',
  isAuthGuardActive: true,
  firebase: {
    apiKey: "AIzaSyCRqaL8UQtb2hDuczfrpH4TWgAFHtYLePQ",
    authDomain: "reda-pro.firebaseapp.com",
    databaseURL: "https://reda-pro.firebaseio.com",
    projectId: "reda-pro",
    storageBucket: "reda-pro.appspot.com",
    messagingSenderId: "468047946479",
    appId: "1:468047946479:web:e7417599f240f12e85311a",
    measurementId: "${config.measurementId}"
  },
  estatus: {
    "NO VIABLE": "rgba(194,0,11,357)",
    "VIABLE": "rgba(244,208,63,1)",
    "MUY VIABLE": "rgba(128,196,28,84)",
    "PROGRAMADO": "rgba(99,7,97,301)",
    "PRECIERRE": "rgba(1,160,198,192)",
    "CERRADO": "rgba(11,1,70,249)",
    "CANCELADO": "rgba(217,83,79,2)",
    "APARTADO": "rgba(1,160,198,192)",
    "VENDIDO": "rgba(11,1,70,249)",
    "ACTIVO": "rgba(128,128,128,1)",
    "ABONO": "rgba(255, 195, 0,1)",
    "ENGANCHE": "rgba(255, 195, 0,1)",
    "RECHAZADO": "rgba(255, 51, 60,1)",
    "ASISTIO": "rgb(29 115 29)",
    "CONFIRMADO": "#ff8200",
    "FORMALIZADO": "#9c27b0",
    "INHABILITADO": "#9E9E9E",
    "REUBICA": "#c2185b", // Color para reubicar una venta
  },
  estatusEventosNew: {
    "CONFIRMADO": "rgb(255 152 0 / 47%)",
    "ASISTIO": "rgb(139 195 74 / 62%)",
    "CANCELADO": "rgb(244 67 54 / 57%)",
    "ACTIVO": "rgb(128 128 128 / 44%)",
    "NUEVO": "rgb(128 128 128 / 44%)",
  },
  estatusSemaforo: {
    "NO VIABLE": "rgba(194,0,11,357)",
    "VIABLE": "rgba(244,208,63,1)",
    "MUY VIABLE": "rgba(128,196,28,84)",
    "PROGRAMADO": "rgba(99,7,97,301)",
    "PRECIERRE": "rgba(1,160,198,192)",
    "CERRADO": "rgba(11,1,70,249)",
    "CANCELADO": "rgba(217,83,79,2)",
    "APARTADO": "rgba(1,160,198,192)",
    "VENDIDO": "rgba(11,1,70,249)",
    "LEAD": "rgba(128,128,128,1)",
    "ABONO": "rgba(255, 195, 0,1)",
    "RECHAZADO": "rgba(255, 51, 60,1)",
    "ASISTIO": "rgb(29 115 29)",
    "CONFIRMADO": "#ff8200",
    "FORMALIZADO": "#9c27b0",
  },

  perfilesParseo: {
    "GV,BK": "Master Comercial",
    "AC,AC": "Asesor",
    "AC,BK": "Broker reda",
    "CM,BK": "Agente reda",
    "DV,BK": "Administrador reda",
    "GV,BK,1": "Coordinador broker reda",
    "GV,AC": "Coordinador comercial",
    "DV,AC": "Director de Venta",
    "RP,BK": "Influencer",
    "CM,AC": "Community Manager",

  },
  estatusParseo: {
    "ACTIVO": "Disponible",
    "ENGANCHE": "Formalizado",
    "APARTADO": "Separado",
    "VENDIDO": "Cerrado",
    "PRECIERRE": "Separado",
    "BLOQUEADO": "Bloqueado",
    "ABONO": "Formalizado",
    "RECHAZADO": "Cancelado",
    "CERRADO": "Cerrado",
    "FORMALIZADO": "Formalizado",
    "INHABILITADO": "Inhabilitado",
    "REUBICA": "Reubicado",
  },
  estatusLoteValue: {
    "BLOQUEADO": "BLOQUEADO",
    "APARTADO": "APARTADO",
    "ACTIVO": "ACTIVO",
    "VENDIDO": "VENDIDO",
    "ENGANCHE": "ENGANCHE",
  },



  estatusPagos: {
    "AUTORIZADO": "Pagado",
    "CAPTURA": "Pendiente",
    "RECHAZADO": "Rechazado",
    "COMPLETADO": "Pagado",
    "PAUSADO": "Pausado",
  },
  estatusColorPagos: {
    "AUTORIZADO": "#4caf50",
    "CAPTURA": "#bc7813",
    "RECHAZADO": "#f44336",
    "COMPLETADO": "#4caf50",
    "PAUSADO": "#3f51b5",
    "CANCELADO": "#f44336",
  },


  meses: {
    "0": "Enero",
    "1": "Febrero",
    "2": "Marzo",
    "3": "Abril",
    "4": "Mayo",
    "5": "Junio",
    "6": "Julio",
    "7": "Agosto",
    "8": "Septiembre",
    "9": "Octubre",
    "10": "Noviembre",
    "11": "Diciembre",
  },
  mesesArray: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  mesesNumero: {
    "Enero": "1",
    "Febrero": "2",
    "Marzo": "3",
    "Abril": "4",
    "Mayo": "5",
    "Junio": "6",
    "Julio": "7",
    "Agosto": "8",
    "Septiembre": "9",
    "Octubre": "10",
    "Noviembre": "11",
    "Diciembre": "12",
  },

  iconosNotificaciones: {
    "CITA": "/assets/img/imgNotificaciones/calendario.png",
    "PROGRAMACION": "/assets/img/imgNotificaciones/calendario-money.png",
    "CITAASISTENCIA": "/assets/img/imgNotificaciones/calendario.png",
    "PROSPECTO": "/assets/img/imgNotificaciones/prospectos.png",
    "ESTRATEGIA": "/assets/img/imgNotificaciones/plan.png",
    "SEMAFORO": "/assets/img/imgNotificaciones/estrella.png",
    "TAREA": "/assets/img/imgNotificaciones/tarea-completada.png",
    "REFERIDO": "/assets/img/imgNotificaciones/prospectos.png",
    "MESATRABAJO": "/assets/img/imgNotificaciones/promocion-color.png",
    "CIERREACCONF": "/assets/img/imgNotificaciones/contract.png",
    "ACELERADOR": "/assets/img/imgNotificaciones/acelerar.png",
    "PROGRAMADO": "/assets/img/imgNotificaciones/clock.png",
    "INCENTIVO": "/assets/img/imgNotificaciones/incentivo.png",
    "PROCESOS": "/assets/img/imgNotificaciones/procesosCompletados.png",
    "ENCUESTA": "/assets/img/imgNotificaciones/nota.png",
    "EQUIPO": "/assets/img/imgNotificaciones/group.png",
  },

  estatusProyectoParseo: {
    'ACTIVO': 'En venta',
    'PAUSADO': 'En pausa',
    'FINALIZADO': 'finalizado',
    'INACTIVO': 'En inactivo',
    'PENDIENTE': 'Pendiente',
  },

  iconosProcesosAplicar: {
    "NOTA": "Nota.png",
    "COTIZADOR": "grafico-de-cotizaciones.png",
    "ACELERADOR": "acelerador.png",
    "ESTRATEGIA": "estrategia-proceso.png",
    "CIERRE": "Cierre.png",
    "REMARKETING": "megafono-proceso.png",
    "BROCHURE": "brochure.png",
    "PRECALIFICACIÓN": "precalificacion.png",
    "FACETOFACE": "facetoface.png",
    "PROGRAMACIÓN": "programacion-proceso.png",
    "MENSAJE": "mensaje.png",
    "CITA": "calendario-proceso.png",
    "PERFILAMIENTO": "perfilamiento.png",
    "LLAMADA": "llamada.png",
    "BODYPERSON CALIENTE": "BodyPerson-caliente.png",
    "BODYPERSON FRIO": "BodyPerson-frío.png",
    "BODYPERSON TIBIO": "BodyPerson-tibio.png"
  },

  etapaLote: {
    "1": "Preventa",
    "2": "Construcción",
    "3": "Inventario"
  },
  nombreComisiones: {
    "AC": "Asesor",
    "BR": "Broker reda",
    "AR": "Agente reda",
    "ADR": "Administrador reda",
    "CBR": "Coordinador broker reda",
    "CC": "Coordinador comercial",
    "MC": "Master comercial",
    "DV": "Director de venta",
    "RP": "Influencer",
    "MBR": "Master broker reda",
    "BK": "Broker reda titular",
    "VPT": "VPT",
    "CM": "Community Manager"
  },

  perfilesFilto: [
    "Master Comercial",
    "Asesor",
    "Broker reda",
    "Agente reda",
    "Administrador reda",
    "Coordinador broker reda",
    "Coordinador comercial",
    "Director de Venta",
    "Influencer",
  ],

  tipoDatoExpedientes: {
    "STRING": "Texto",
    "INT": "Número entero",
    "DOUBLE": "Numérico",
    "DATE": "Fecha"
  },

  estatusArrayVenta: [
    { label: "PRECIERRE", value: "PRECIERRE", color: "rgba(1,160,198,192)" },
    { label: "CERRADO", value: "CERRADO", color: "rgba(11,1,70,249)" },
    { label: "ABONO", value: "ABONO", color: "rgba(255, 195, 0,1)" },
    { label: "RECHAZADO", value: "RECHAZADO", color: "rgba(255, 51, 60,1)" },
    { label: "INHABILITADO", value: "INHABILITADO", color: "#9E9E9E" },
    { label: "REUBICA", value: "REUBICA", color: "#c2185b" } // Color para reubicar una venta
  ],

  estatusParseoVenta: {
    "PRECIERRE": "Separado",
    "BLOQUEADO": "Bloqueado",
    "ABONO": "Formalizado",
    "RECHAZADO": "Cancelado",
    "CERRADO": "Cerrado",
    "INHABILITADO": "Inhabilitado",
    "TODOS": "Todos",
    "FORMALIZADO": "Formalizado",
    "REUBICA": "Reubicado",
  },

  iconsButtons: {
    "QUICK_REPLY": "fas fa-reply",
    "PHONE_NUMBER": "fas fa-phone",
    "EMAIL": "fas fa-envelope",
    "LINK": "fas fa-link",
  },
  colorestadoTemplate: {
    "ACTIVO": "rgb(40 167 69 / 81%)",
    "INACTIVO": "#dc3545",
    "APPROVED": "rgb(40 167 69 / 81%)",
    "REJECTED": "#dc3545",
    "PENDING": "#ffc107",
  },

  tourConfiguracion: {
    "tituloMarketingInmobiliario": "Marketing Inmobiliario",
    "descripcionMarketingInmobiliario": "En esta sección podrás cargar todo lo necesario para gestionar el marketing de tu proyecto inmobiliario." +
      "Esto incluye modelos, lotificación, brochures, amenidades, y cualquier otro material relevante. Además, podrás definir las metas que deseas alcanzar con tu área de marketing para este proyecto.",

    "tituloTourMarketingBusiness": "Marketing Business",
    "descripcionTourMarketingBusiness": "En esta sección podrás cargar los brochures y definir las metas que deseas alcanzar con tu área de marketing." +
      "Esta configuración te ayudará a establecer los objetivos clave y gestionar los materiales necesarios para tu proyecto.",

    "tituloTourUsuarios": "Marketing Business",
    "descripcionTourUsuarios": "En esta sección podrás dar de alta a los usuarios que tendrán acceso principal a la plataforma, como directores, gerentes y coordinadores. Estos roles clave serán quienes gestionen y administren la plataforma" + " </br> " +
      "Nota: Más adelante podrás agregar a tu equipo de ventas, pero este proceso se realizará en una sección diferente.",

    "tituloTourFinanzas": "Finanzas",
    "descripcionTourFinanzas": "En esta sección podrás configurar todo lo necesario para gestionar las finanzas de tu proyecto inmobiliario. Podrás agregar el inventario del proyecto, establecer esquemas financieros, y configurar las comisiones de tu equipo de ventas.",

    "descripcionTourFinanzasBusiness": "En esta sección podrás configurar las finanzas de tu proyecto BS. Aquí podrás agregar el inventario de productos, definir esquemas financieros, y configurar las comisiones de tu equipo de ventas.",

    "descripcionTourVentas": "En esta sección, también podrás definir las metas de tu fuerza de ventas para alinear sus objetivos con las estrategias del proyecto.",

    "descripcionTourProcesos": "En esta sección podrás definir los pasos que tus vendedores deberán seguir para cerrar una venta con sus prospectos.Es una de las configuraciones más importantes, ya que establece el camino que cada vendedor debe seguir. Además, puedes agregar procesos adicionales como la gestión de documentos digitales y la documentación de clientes.",

    "descripcionTourFinalizado": "En esta sección concluirás la configuración de tu proyecto." + " </br> " +
      "Una vez que hayas completado la carga de todos los elementos de tu proyecto, presiona Finalizar.Esto confirmará que has recorrido con éxito todo el proceso y que la configuración ha sido completada correctamente."
  },

  formatslocale: {
    GTQ: 'es-GT',   // Moneda y localización para Guatemala
    USD: 'en-US',   // Moneda y localización para Estados Unidos
    EUR: 'fr-FR',   // Moneda y localización para Europa
    MXN: 'es-MX'    // Moneda y localización para México
  },

  estatusPedidoTienda: {
    0: "En carrito",
    1: "Pagado",
    2: "Local",
    3: "Guia generada",
    4: "Paqueteria",
    5: "En curso",
    6: "Entregado en casa",
    7: "Cancelado"
  },

  colorEstatusPedidoTienda: {
    0: "#FFA500",
    1: "rgb(40 167 69 / 81%)",
    2: "#2196F3",
    3: "#9C27B0",
    4: "#FF9800",
    5: "#FFC107",
    6: "#4CAF50"
  },

  estatusClienteTienda: {
    0: "Pendiente",
    1: "Pagado",
  },

  imagenesTipoCampana: {
    1: "GeneraQR.png",
    2: "LandingPage.png",
    3: "Webhooks.png",
    4: "Marketing.png",
    5: "facebooklogo.png",
  },

  tipoPlanSuscripcion: {
    1: "Plan Starter",
    2: "Plan Plus",
    5: "Plan Mensual",
    4: "Plan Anual",
  },
  cvkeycheck: {
    "cvkeycheck": "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",
  },
  openaiProjectId: 'proj_wQE0YoW567o2eOUcqWRJHzLI',
  tkIAReda: "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"

};
